import { Button } from 'antd'
import DrawerBox from '../../../components/common/DrawerBox'
import { isMobile } from 'react-device-detect'
import { AiFillPushpin } from 'react-icons/ai'

function AdminPanelLeaderBoard({ open, setOpen, broadcastLeaderBoard }) {
  return (
    <DrawerBox placement={isMobile ? 'bottom' : 'right'} headerStyle={{ display: 'none' }} bodyStyle={{ padding: '16px' }} width='450px' visible={open} setVisible={setOpen}>
      <div className='height-full flex fd-column'>
        <h3 className='mb-16'>Are you sure you want to send out leader board? This will internally re-compute the leader board and then broadcast it to the users.</h3>
        <div className='font-size-14 font-color-red font-bold-500 block'>
          <i>Note : Please send out the leader board only after completing all the sections and questions within the sections.</i>
        </div>
        <div className='mt-16 flex jc-space-between'>
          <Button type='primary' ghost danger onClick={() => setOpen(false)} className='flex items-center width-fit-content font-bold-600'>
            No
          </Button>
          <div type='primary' size='large' onClick={broadcastLeaderBoard} className='button-gradient font-bold-600 jc-center flex items-center pt-6 pb-6 pl-12 pr-12 rounded-12 font-color-white cursor-pointer' style={{ border: 'none' }}>
            <AiFillPushpin className='mr-8' /> Yes
          </div>
        </div>
      </div>
    </DrawerBox>
  )
}

export default AdminPanelLeaderBoard
